import Axios from 'axios';
import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { GroupsApplicationItem, PushGroupsApplicationFilter, GroupsApplicationsState } from './types';
import axios from "axios";

export const actions: ActionTree<GroupsApplicationsState, RootState> = {
  getGroupsApplications: ({ commit }, data: PushGroupsApplicationFilter) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({ url: '/acapi/push/applications/groups', params: data })
        .then(resp => {
          commit('setGroupsApplications', resp.data.groups);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  getGroupsApplicationItem: ({ commit }, id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({ url: `/acapi/push/applications/groups/${id}` })
        .then((resp: any) => {
          let groupsApplicationItem = <GroupsApplicationItem>resp.data;
          groupsApplicationItem.id = id;
          commit('setGroupsApplicationItem', groupsApplicationItem);
          resolve(groupsApplicationItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  saveGroupsApplicationItem: ({ commit, dispatch }, data: GroupsApplicationItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/push/applications/groups/' + (data.id ?? ''),
        data: data
      })
        .then((resp: any) => {
          dispatch('getGroupsApplications');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  saveGroupsApplicationPriority: ({commit, dispatch}, data:any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/acapi/push/applications/groups/priority',
        data: data
      })
          .then((resp: any) => {
            resolve(resp)
          })
          .catch((err: any) => {
            reject(err)
          })
          .finally(() => commit('setLoading', false));
    })
  },
  deleteGroupsApplicationItem: ({ commit, dispatch }, data: GroupsApplicationItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({
        method: 'delete',
        url: `/acapi/push/applications/groups/${data.id}`,
        data: data
      })
        .then((resp: any) => {
          dispatch('getGroupsApplications');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  }
};
